import authActions from 'reduxStore/action/authActions';

export default {
  ...authActions,
};
